import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { KebabMenu, KebabMenuItem } from 'components/KebabMenu'
import { JobInfoHeaderMenuMessages } from './messages'
import DeleteJobModal from './DeleteJobModal'
import RenameJobModal from './RenameJobModal'
import { commonMessages } from 'app/i18n/messages'
import SuccessModal from 'components/Modal/SuccessModal'
import MoveJobModal from './MoveJobModal'

function JobInfoHeaderMenu() {
  const { formatMessage } = useIntl()
  const [isRenameJobOpen, setIsRenameJobOpen] = useState<boolean>(false)
  const [isDeleteJobOpen, setIsDeleteJobOpen] = useState<boolean>(false)
  const [isMoveJobOpen, setIsMoveJobOpen] = useState<boolean>(false)
  const [error, setError] = useState<object | undefined>()

  return (
    <>
      {isMoveJobOpen && (
        <MoveJobModal setIsMoveJobOpen={setIsMoveJobOpen} setError={setError} />
      )}
      {isRenameJobOpen && (
        <RenameJobModal
          setIsRenameJobOpen={setIsRenameJobOpen}
          setError={setError}
        />
      )}

      {isDeleteJobOpen && (
        <DeleteJobModal
          setIsDeleteJobOpen={setIsDeleteJobOpen}
          setError={setError}
        />
      )}

      {error && (
        <SuccessModal
          title={formatMessage(commonMessages.error)}
          isOpen
          confirmBtnTitle={formatMessage(commonMessages.ok)}
          onConfirm={() => setError(undefined)}
        >
          {formatMessage(commonMessages.commonError)}
        </SuccessModal>
      )}

      <KebabMenu>
        <KebabMenuItem
          title={<FormattedMessage {...JobInfoHeaderMenuMessages.rename} />}
          onClick={() => setIsRenameJobOpen(true)}
        />
        <KebabMenuItem
          title={<FormattedMessage {...JobInfoHeaderMenuMessages.move} />}
          onClick={() => setIsMoveJobOpen(true)}
        />
        <KebabMenuItem
          title={<FormattedMessage {...JobInfoHeaderMenuMessages.delete} />}
          onClick={() => setIsDeleteJobOpen(true)}
        />
      </KebabMenu>
    </>
  )
}

export default JobInfoHeaderMenu
